// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  color-scheme: light dark;
}

body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  height: 100vh;
  font-family: 'Poppins', sans-serif;
}

#appbar {
  -webkit-app-region: drag!important;
}

#appbar-controls {
  -webkit-app-region: no-drag!important;
}

@keyframes screen-shake {
  0% {
    transform: translateX(0) translateY(0);
  }

  25% {
    transform: translateX(var(--shake-x, 0)) translateY(var(--shake-y, 0));
  }

  50% {
    transform: translateX(calc(var(--shake-x, 0) * -1)) translateY(calc(var(--shake-y, 0) * -1));
  }

  75% {
    transform: translateX(var(--shake-x, 0)) translateY(var(--shake-y, 0));
  }

  100% {
    transform: translateX(0) translateY(0);
  }
}

.screen-shake {
  animation: screen-shake 0.25s;
}

@media (prefers-color-scheme: dark) {
  body {
    background: #141A21;
    color: #fff;
  }
}

@media (prefers-color-scheme: light) {
  body {
    background: #ddd;
    color: black;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,sCAAsC;EACxC;;EAEA;IACE,sEAAsE;EACxE;;EAEA;IACE,4FAA4F;EAC9F;;EAEA;IACE,sEAAsE;EACxE;;EAEA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,mBAAmB;IACnB,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;AACF","sourcesContent":[":root {\r\n  color-scheme: light dark;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  height: 100vh;\r\n  font-family: 'Poppins', sans-serif;\r\n}\r\n\r\n#appbar {\r\n  -webkit-app-region: drag!important;\r\n}\r\n\r\n#appbar-controls {\r\n  -webkit-app-region: no-drag!important;\r\n}\r\n\r\n@keyframes screen-shake {\r\n  0% {\r\n    transform: translateX(0) translateY(0);\r\n  }\r\n\r\n  25% {\r\n    transform: translateX(var(--shake-x, 0)) translateY(var(--shake-y, 0));\r\n  }\r\n\r\n  50% {\r\n    transform: translateX(calc(var(--shake-x, 0) * -1)) translateY(calc(var(--shake-y, 0) * -1));\r\n  }\r\n\r\n  75% {\r\n    transform: translateX(var(--shake-x, 0)) translateY(var(--shake-y, 0));\r\n  }\r\n\r\n  100% {\r\n    transform: translateX(0) translateY(0);\r\n  }\r\n}\r\n\r\n.screen-shake {\r\n  animation: screen-shake 0.25s;\r\n}\r\n\r\n@media (prefers-color-scheme: dark) {\r\n  body {\r\n    background: #141A21;\r\n    color: #fff;\r\n  }\r\n}\r\n\r\n@media (prefers-color-scheme: light) {\r\n  body {\r\n    background: #ddd;\r\n    color: black;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
